import(/* webpackMode: "eager" */ "/home/runner/_work/hg-client/hg-client/apps/web/src/app/(blank)/layout.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/hg-client/hg-client/node_modules/next/dist/client/script.js");
